import { h } from 'preact';
import { CardSkeleton } from '../CardSkeleton';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'CardSkeleton',
  category: '⏳ Loading',
  description: 'Skeleton de cards em grid ou lista para loading de conteúdo',
  usedIn: ['AgentesPage', 'Integrations'],
  example: () => (
    <CardSkeleton count={3} layout="grid" cols={3} />
  ),
};
